module.exports = __webpack_public_path__ + "img/bg-20.d04a8b24.png";